'use strict';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { Itab } from '@ispm/shared/interfaces/Itab';
import { IcurationWorklistItem } from '../../interfaces/curation-worklist-item.interface';
import { CurationSettings, CurationTypes } from './curation-setting';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { PlaceholderModalComponent } from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, flatMap, take, takeUntil } from 'rxjs/operators';
import 'rxjs/add/observable/empty';
import { CurationActionCreatorService } from '../../services/curation-action-creator.service';
import { CurationMatchFoundComponent } from '../curation-match-found/curation-match-found.component';
import { ICurationCreateRequest } from '../../interfaces/curation-create-request.interface';
import { CurationEditorHelper } from '../curation-editor/curation-editor-helper';
import { CurationCloningSelectionComponent } from './curation-cloning-selection/curation-cloning-selection.component';
import { PlaceholderModalLoaderPayload } from '@ispm/layout/classes/placeholder-modal-loader-payload';
import { IWorklistAction } from '../../../worklist/interfaces/worklist-action.interface';
import { WorklistAction } from '../../../worklist/classes/worklist-action.class';
import { CurationUtils } from '../../utils/curation-utils';
import { CurationDashboardOperations } from './services/curation-dashboard-interface';
import { curationDashboardAberrationService } from './services/curation-dashboard-aberration-service';
import { curationDashboardPathwaysService } from './services/curation-dashboard-pathways-service';
import { curationDashboardWorklistService } from './services/curation-dashboard-worklist-service';
import { curationDashboardClinicalTrialService } from './services/curation-dashboard-clinicaltrials-service';
import { FilterService } from '../../../filter/services/filter.service';
import { Filter } from '../../../filter/classes/filter';
import { EXPORT_DATA_STORAGE_KEY, FILTERS_STORAGE_KEY } from '@ispm/shared/services/ui-customization.service';
import { CurationUpdateNode } from '../../classes/curation-update-node';
import { CurationService } from '../../services/curation.service';
import { BpmnDeploymentService } from '@ispm-client/modules/bpmn-modeler/service/bpmn-deployment.service';
import { BpmnXmlService } from '@ispm/shared/bpmn/services/bpmn-xml.service';
import { CurationItemPermissions } from '../curation-editor/curation-enums';
import { CurationItemNotFoundComponent } from '../curation-item-not-found/curation-item-not-found.component';
import { camelCase, cloneDeep, get, has, set, isEmpty } from 'lodash';
import { LogService } from '@ispm/core/services/log.service';
import { IGrantedAction } from '../../../worklist/interfaces';
import { ITablelistExecute } from '../../../worklist/interfaces';
import { WorklistExecute } from '../../../worklist/classes/worklist-execute.class';
import { curationDashboardPlacementService } from './services/curation-dashboard-placement-service';
import { CurationModalMessageComponent } from './curation-modal-message/curation-modal-message.component';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { INavigationApplicationInterface } from '@ispm/navigation/interfaces';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {
  FilterPanelWrapperComponent
} from '../../../filter/components/filter-panel-wrapper/filter-panel-wrapper.component';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { Router } from '@angular/router';
import { ErrorMessages } from "@ispm/shared/constants/error-messages";
import { FilterUtils } from "../../../filter/utils/filter-utils";
import {WorklistService} from "../../../worklist/services/worklist.service";

@Component({
  selector: 'gen-curation-dashboard',
  templateUrl: './curation-dashboard.component.html',
  styleUrls: ['./curation-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class CurationDashboardComponent implements OnInit, OnDestroy {
  public list: Subject<any> = new Subject<any>();
  public confMap: any;
  public tabs: Itab[] = [];
  public curationToTab: any = { };
  public newItemOptions: any[] = [];
  public createButtonText: string;
  public tunnel$: Subject<any>;
  public callback: (selectedUserId: string) => void;
  public currentTab: string;
  public searchText: string;
  public searchResource: string = '';
  public filterFormName: string;
  public viewOnlyMode: boolean = false;
  public curationWriteMode: boolean = false;
  public filterEnabled: boolean = false;
  public destroyer$: Subject<any> = new Subject();
  public filterSearch: Subject<string> = new Subject<string>();
  public text: string;
  public loading: boolean = false;
  public placeHolderText: string = 'Search';
  public curationToCreate: ICurationCreateRequest;
  public curationTypeByFormName: Map<string, any> = new Map();
  public curationMainType: string = 'curationInfo';
  public curationType: string;
  public enableStatistics: boolean = false;
  public appliedFilterProperties: any[] = [];
  public injectActions: IWorklistAction[] = [];
  public searchString: string = '';
  public grantedActionsTable: IGrantedAction[];
  public executeActions: ITablelistExecute[] = [];
  public isFilterPanelOpen;
  public filteredResultsMessage: string;
  public worklistType: string = 'curation';
  public tabsDisabled: boolean = false;
  private modalSubscriber$: Subscription;
  private curationMatchmodalSubscriber$: Subscription;
  private appliedFilter$: Subscription;
  private appliedFilterTabChange$: Subscription;
  private curationDashboardService: CurationDashboardOperations;
  private currentConf: any = { };
  // KB definitions for this organization, such as DFCI_Curation_KB_Definition.
  private generalDbConf: any;
  private trialId: string;
  private curationItemModelSubscriber$: Subscription;
  private cloneShowForm: EventEmitter<any> = new EventEmitter<any>();
  private currentApp: INavigationApplicationInterface;
  @ViewChild('filterPanelWrapper',  { static: false}) public filterPanelWrapper: FilterPanelWrapperComponent;
  private fromTabChange: boolean = false;
  listData: Subscription;
  curationParams: { appname: any; };
  private dataIsLoaded$ = new BehaviorSubject<boolean>(false);
  constructor(private modalLoader: DynamicModalLoaderService,
              private router: Router,
              private curationActionCreatorService: CurationActionCreatorService,
              private authService: AuthenticationService,
              private curationService: CurationService,
              private filterService: FilterService,
              private bpmnXmlService: BpmnXmlService,
              private logservice: LogService,
              genomicsStore: Store<IgenomicsState>,
              private injector: Injector,
              private notificationMessageService: NotificationMessageService,
              private _changeDetector: ChangeDetectorRef) {
    genomicsStore.select('navigation', 'currentApp').subscribe((app) => {
      this.currentApp = app;
    });

    this.filterSearch
      .pipe(debounceTime(300),
        distinctUntilChanged())
      .subscribe((value: string) => {
        this.onSearchExecute(value);
      });
  }

  get cloningEnabled(): boolean {
    return this.curationDashboardService ? this.curationDashboardService.getCloningEnabled() : false;
  }

  public updatePanelState(event: boolean) {
    this.isFilterPanelOpen = event;
  }

  async ngOnInit() {
    this.setFilterResultsCounterMessage(0);
    this.getConfData();

    let appliedFilterQueryString = '';
    if (!this.filterEnabled) {
      appliedFilterQueryString = '{}';
      const data = await this.loadDataFromServer(appliedFilterQueryString).toPromise();
      this.list.next(data);
    } else {
      this.appliedFilter$ = this.loadFiltersFromServer()
        .pipe(
          takeUntil(this.destroyer$.asObservable())
        )
        .subscribe(async(queryObj) => {
          if (queryObj) {
            appliedFilterQueryString = JSON.stringify(queryObj);
            const data = await this.loadDataFromServer(appliedFilterQueryString).toPromise();
            this.list.next(data);

          }
        });
      this.filterService.getAppliedFilterPropertiesFromStore()
        .subscribe(appliedFilterProps => {
          this.appliedFilterProperties = appliedFilterProps ? appliedFilterProps : [];
        });
    }

    this.cloneShowForm.subscribe(payload => {
      this.showCloneForm(payload.conf, payload.rowData);
    });
  }

  getConfData() {
    this.curationActionCreatorService.getState(['definitions'])
      .take(1)
      .subscribe((data => {
        this.confMap = Array.from(data.values()).filter(data => data['type'] === this.curationType || data['type'] === 'curationKB');
        this.generalDbConf = this.confMap.filter(data => data['type'] === CurationSettings.CURATION_KB && data['id'] === this.curationActionCreatorService.getActiveKB())[0];
        this.grantedActionsTable = this.curationActionCreatorService.findGrantedActionsTable(this.generalDbConf);

        this.curationDashboardService = this.getCurationDashboardService();
        this.curationDashboardService.loadAddItemOptions(this.generalDbConf, this.newItemOptions, this.curationTypeByFormName, this.loadForm, this);

        this.viewOnlyMode =
          this.authService.doesUserHasPermission(CurationItemPermissions.WRITE_CURATION_ITEM_PERMISSION) == false
          && this.authService.doesUserHaveRegExpPermission('CURATIONITEM\..+\.WRITE') == false
          && this.authService.doesUserHasPermission(CurationItemPermissions.APPROVE_CURATION_ITEM_PERMISSION) == false
          && this.authService.doesUserHasPermission(CurationItemPermissions.REVIEW_CURATION_ITEM_PERMISSION) == false;
        // load tabs data
        this.loadTabs();

        if (!this.grantedActionsTable && (!this.viewOnlyMode && this.cloningEnabled)) {
          this.injectActions.push(WorklistAction.builder(CurationSettings.GRANTED_ACTIONS_CLONE_ACTION, CurationSettings.GRANTED_ACTIONS_CLONE_ACTION, this.openCloningSelectionForm.bind(this), this.enableCondition.bind(this)));
          this.injectActions = [...this.injectActions];
        }
      }));
  }

  enableCondition(self): boolean {
    return (self.rowData.status !== 'Publish in Progress' && self.rowData.status !== 'Archive in Progress');
  }

  openEditor(curationId: string, workflowRequestId: string, revisionId: string, curationType: string,
             relatedEntity: any = undefined) {
    if (!revisionId) {
      revisionId = '';
    }
    this.filterService.storeState();

    // Open related editor, look at routing
    // GEN-64430: for placement from pathwayBpmn:
    //     if there is related entity then update it first inside opened editor
    this.toggleSpinner(false);
    this.router.navigate(['curation', curationId, workflowRequestId, revisionId, curationType], {queryParamsHandling: 'preserve'});
  }

  ngOnDestroy(): void {
    CurationSettings.lastSearch = this.searchText;
    if (this.modalSubscriber$) {
      this.modalSubscriber$.unsubscribe();
    }
    if (this.appliedFilter$) {
      this.appliedFilter$.unsubscribe();
    }
    if (this.appliedFilterTabChange$) {
      this.appliedFilterTabChange$.unsubscribe();
    }
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  public clearAllAppliedFilters(): void {
    this.filterService.clearAppliedFilters();
  }

  public loadForm(formName, titleText: string, itemData: { type: string, inputs: IoptionElemet[] }) {
    let curationToCreate: ICurationCreateRequest;
    const createData = this.curationDashboardService.getCurationCreationData(itemData, formName);

    this.modalSubscriber$ = this.modalLoader.popupModal(PlaceholderModalComponent, {
      title: `<span class="plus-icon-container"><span class="plus-icon-inner-container"><i class="icon__plus"</span></span></i>Add ${titleText}`,
      componentToLoad: createData['createComp'],
      buttons: {
        approveBtn: 'Continue',
        declineBtn: 'Cancel'
      },
      payload: createData['payload'],
      approveCallback: (model) => {
        return this.createCuration(model);
      }
    }, ModalTypes.NONE)
      .filter(response => response.payload)
      .map(response => response.payload)
      .finally(() => {
        // this.loadMatchAberrationForm();
      })
      .subscribe((response: any) => {
        // return Observable.empty<Response>();
      });
  }

  public loadMatchItemForm(itemData: any, checkData: boolean = true) {
    if (checkData && (!has(itemData, 'curationData') || !has(itemData, 'curationItem'))) {
      this.notificationMessageService.error('Fail to open curation item, returned data is not right');
    }
    const params = this.curationDashboardService.openEditorParams(itemData);
    if (itemData.curationData == null) { // this condition should be checked only for aberrations ?
      this.openEditor(params.curationId, params.wfId, params.revisionId, params.curationType);
    }
    else {
      this.toggleSpinner(false);
      let openEditor = false;

      const content = itemData.curationData.content;
      const curationType = itemData.type || itemData.curationItem.type; // support "old" curation type (aberrations) and new types
      let theTitle = `A matching item already exists`;
      let theName = this.getCurationItemName(curationType, itemData.curationData.content);

      if (curationType === CurationSettings.CURATION_CLINICALTRIAL) {
        // MDA trial curation
        theTitle = 'The clinical trial ' + content.trialId + ' already exists';
        theName = content.trialId;
      }
      this.curationMatchmodalSubscriber$ = this.modalLoader.popupModal(PlaceholderModalComponent, {
        title: theTitle,
        componentToLoad: CurationMatchFoundComponent,
        buttons: {
          approveBtn: `Open ${theName}`,
          declineBtn: 'Back'
        },
        payload: {
          itemData: itemData,
          curationType: curationType,
          curationItemName: theName
        },
        approveCallback: (model) => {
          openEditor = true;
          return Observable.of(true);
        },
      }, ModalTypes.ALERT)
        .finally(() => {
          if (openEditor) {
            this.openEditor(params.curationId, params.wfId, params.revisionId, params.curationType);
          }
        })
        .subscribe(() => {
        });
    }
  }

  public showValidationWarning(itemData: any): Observable<boolean> {
    const theContent = `A matching ${this.curationType} ${itemData.error.message}`;
    this.curationMatchmodalSubscriber$ = this.modalLoader.popupModal(PlaceholderModalComponent,
      {
        componentToLoad: CurationModalMessageComponent,
        buttons: {
          approveBtn: 'Close',
          declineBtn: ''
        },
        approveCallback: () => {
          return Observable.of(true);
        },
        payload: {
          content: theContent
        },
      }, ModalTypes.ALERT)
      .subscribe((response) => {
      });
    return Observable.of(true);
  }

  loadTabs() {
    const tabs: Itab[] = this.generalDbConf['ui']['tabs'];
    if (this.viewOnlyMode && !this.authService.user.isAdmin) { // Worklist tab should not be available in view only mode BUT should always be avaialbe for admins (GEN-41918)
      const tabIdx = tabs.findIndex((tab) => tab.name.includes(CurationSettings.TAB_WORKLIST_LABEL));
      if (tabIdx >= 0) {
        tabs.splice(tabIdx, 1);
      }
    }
    this.tabs = tabs;
    this.filterFormName = this.getTabFilterFormName(this.currentTab);
    this.filterEnabled = (this.filterFormName && this.filterFormName != '');
    this.curationToTab = this.generalDbConf['ui']['curationToTab'];
    // select first available tab
    if (this.tabs.length >= 0) {
      const filtersFromSessionCache = FilterUtils.loadFromSessionCache();
      const selectedTabName: string = filtersFromSessionCache?.currentSelectedTab ? filtersFromSessionCache.currentSelectedTab : this.tabs[0].name;
      this.setCurrentTabData(selectedTabName);
    }
  }

  async onTabChange(tabName: string) {
    this.dataIsLoaded$
      .pipe(
        takeUntil(this.destroyer$.asObservable()),
        filter(data => data)
      ).take(1)
      .subscribe(() => {
      if (this.currentTab === tabName || this.tabsDisabled) {
        return;
      } else {
        this.curationWriteMode = false;
        this.fromTabChange = true;

        this.setFilterResultsCounterMessage(0);
        if (sessionStorage.getItem(EXPORT_DATA_STORAGE_KEY)) {
          sessionStorage.removeItem(EXPORT_DATA_STORAGE_KEY);
          this.filterService.setSelectedRows([]);
        }
        if (sessionStorage.getItem(FILTERS_STORAGE_KEY)) {
          sessionStorage.removeItem(FILTERS_STORAGE_KEY);
        }
        if (this.currentTab !== tabName) {
          try {
            CurationSettings.lastCurationPage = -1;
            this.toggleSpinner(true);
            this.tabsDisabled = true;
            this.setCurrentTabData(tabName);
            if (!this.filterEnabled || this.curationType === 'aberration') { // No filters for aberration
              this.loadDataFromServer('{}').subscribe(async () => {
                const data = await this.loadDataFromServer('{}').toPromise();
                this.list.next(data);
                this.tabsDisabled = false;
              });
            }
            else {
              this.appliedFilterTabChange$ = this.loadFiltersFromServerOnTabChange()
                .pipe(
                  takeUntil(this.destroyer$.asObservable()),
                  flatMap((filters) => {
                    return this.filterService.getAppliedFilterPropertiesFromStore();
                  })
                )
                .subscribe((appliedFilterProperties) => {
                  this.appliedFilterProperties = appliedFilterProperties;
                  this.tabsDisabled = false;
                  if (this.filterEnabled && this.isFilterPanelOpen && !!this.fromTabChange) {
                    this.initFilterPanel();
                  }
                  this.fromTabChange = false;
                });

            }
          } catch (e) {
            this.tabsDisabled = false;
          }
        }

        // clean search field
        this.text = '';
        this.searchText = '';
        this.searchResource = '';
        this.onSearchChange('');
      }
    });
  }

  private initFilterPanel() {
    this.filterPanelWrapper.type = this.curationMainType;
    this.filterPanelWrapper.subtype = this.curationType;
    this.filterService.setFilterType(this.curationMainType, this.curationType);
    this.filterPanelWrapper.toggleFilterPanel();
  }

  setCurrentTabData(tabName: string) {
    if (this.currentTab !== tabName) {
      this.filterService.setCurrentSelectedTab(tabName);

      this.list.next([]); // empty the list until we reload the items
      this.currentTab = tabName;
      this.createButtonText = 'Add ' + this.curationToTab[this.currentTab].buttonText;
      this.filterFormName = this.getTabFilterFormName(this.currentTab);
      this.filterEnabled = (this.filterFormName && this.filterFormName !== '');
      this.curationType = this.curationToTab[this.currentTab].entityName;
      this.worklistType = this.curationToTab[this.currentTab].worklistType;

      this.prepareActionsByGrantedTable();

      this.curationActionCreatorService.getState(['definitions'])
        .take(1)
        .subscribe((data => {
          this.confMap = Array.from(data.values()).filter(data => data['type'] === this.curationType || data['type'] === 'curationKB');
          const dbConf = this.generalDbConf; // this.confMap.filter(data => data['type'] === CurationSettings.CURATION_KB && data['id'] === this.curationActionCreatorService.getActiveKB())[0];
          const typeConf = this.confMap.filter(data => data['type'] === this.curationType)[0];
          this.curationDashboardService = this.getCurationDashboardService();
          if (dbConf['ui'] && dbConf['ui']['forms']) {
            this.curationDashboardService.loadAddItemOptions(dbConf, this.newItemOptions, this.curationTypeByFormName, this.loadForm, this);
          }
        }));
    }
  }

  onSearchChange(searchStr: string) {
    // When user deletes the filter and click on enter 'onSearchClear' event is not called so triggering the filter clear here instead.
    if (sessionStorage.getItem(EXPORT_DATA_STORAGE_KEY)) {
      sessionStorage.removeItem(EXPORT_DATA_STORAGE_KEY);
      this.filterService.setSelectedRows([]);
    }
    this.filterSearch.next(searchStr);
    this.searchResource = this.worklistType;
  }

  onSearchExecute(searchStr: string) {
    // this.loading = true;
    this.searchText = searchStr;
    this.searchResource = this.worklistType;
    this._changeDetector.detectChanges();
  }

  onSearchClear(searchStr: string) {
    this.toggleSpinner(false);
    this.searchText = searchStr;
    this.searchResource = this.worklistType;
  }

  loadingCompleted(rowsCount: number) {
    this.toggleSpinner(false);
  }

  getTabFilterFormName(currentTab: string): string {
    const filteredTabs: Itab[] = this.tabs.filter(tab => {
      if (tab.name === this.currentTab) {
        return tab.filterFormName;
      }
    });

    // tslint:disable-next-line:max-line-length
    return (filteredTabs.length > 0 && filteredTabs[0].filterFormName && filteredTabs[0].filterFormName !== '') ? filteredTabs[0].filterFormName && filteredTabs[0].filterFormName : null;
  }

  dashboardItemClick(curationItem: IcurationWorklistItem) {
    this.openEditor(curationItem.curationItemId, curationItem.workflowRequestId, curationItem.revisionId, curationItem.type);
  }

  cloneDiseaseEvent($event) {
    const curationItemId = $event['curation']['curationItemId'];
    const revisionId = $event['curation']['revisionId'];
    const disease = $event['selectedDisease'];
    const opinion = CurationUtils.buildOpinion(this.authService.user);

    const curationItem$ = this.curationActionCreatorService.cloneCurationItem(curationItemId, revisionId, disease, opinion)
      .catch((error: any) => {
        return Observable.of({ });
      })
      .publish();
    curationItem$.connect();
    curationItem$.subscribe((response: any) => {
      if (response['error']) {
        if (response['status'] == CurationEditorHelper.ERROR_DUPLICATE_ITEM) {
          // get the details of the current aberration
          this.curationActionCreatorService.getCurationItem(curationItemId, revisionId).subscribe(res => {
            const currentAberration = res['aberration'];
            let data: ICurationCreateRequest;
            data = {
              'disease': disease.code,
              'diseaseDisplay': disease.display,
              'type': 'aberration',
              'opinion': opinion,
              'aberration': currentAberration
            };
            // get details of the existing (the duplicatation target) aberration
            this.curationActionCreatorService.getCurationItemByKeys(data).subscribe(res => {
              this.loadMatchItemForm(res, false);
            });
          });
        }
        else {
          console.error('Cloning failed for curationItemId = ' + curationItemId + ', disease = ' + disease + '.Error: ' + response['error']);
        }
      }
      else {
        this.openEditor(response.id, response.workflowRequestId, response.currentWorkflowRequestRevision, response['type']); // ToDo get currect type
      }
      return response;
    });
  }

  updateNoteComplete(row) {
    this.curationType = row.type;
    if (row['hasNotesUpdate']) {
      this.curationActionCreatorService.updateHasNotes(row.curationInfoId, row.type)
        .take(1)
        .catch((error: any) => {
          return Observable.of(error);
        })
        .publish();
    }
  }

  loadCurationForm() {
    const conf = this.confMap.filter(data => data['type'] === this.curationType);
    const formConf = conf[0]['ui']['forms']['createForms'][this.curationType];
    this.loadForm(formConf['formName'], formConf['label'], null);
  }

  getAdditionalValidationSet(): string[] {
    const conf = this.confMap.filter(data => data['type'] === this.curationType);
    return get(conf[0], 'ui.forms.createForms.' + this.curationType + '.additionalValidation', undefined);
  }

  pageChanged(pageNum: number) {
    CurationSettings.lastCurationPage = pageNum;
  }

  // this function is injected from worklist
  public grantedClonedEnabledForItem(self) {
    if (this.viewOnlyMode) { return false; }

    return this.grantedActionsTable.some(action => {
      return (action.action === CurationSettings.GRANTED_ACTIONS_CLONE_ACTION
        && (action.types.some(typeDescr => typeDescr.curationType === self.rowData.type && typeDescr.source.includes(self.rowData.kb)))
        && action.userIsPermittedForAction);
    });
  }

  public cssClassFormat(className: string) {
    return StringUtils.cssClassFormat(className);
  }

  private getCurationDashboardService() {
    switch (this.curationType) {
      case CurationSettings.CURATION_ABERRATION:
        return this.injector.get(curationDashboardAberrationService);
      case CurationSettings.CURATION_PATHWAY:
        return this.injector.get(curationDashboardPathwaysService);
      case CurationSettings.CURATION_SUMMARY:
        return this.injector.get(curationDashboardPathwaysService);
      case CurationSettings.CURATION_WORKLIST:
        return this.injector.get(curationDashboardWorklistService);
      case CurationSettings.CURATION_CLINICALTRIAL:
        return this.injector.get(curationDashboardClinicalTrialService);
      case CurationSettings.CURATION_MDA_WORKLIST:
        return this.injector.get(curationDashboardWorklistService);
      case CurationSettings.CURATION_PLACEMENT:
        return this.injector.get(curationDashboardPlacementService);
      default:
        return this.injector.get(curationDashboardPathwaysService);
    }
  }

  private loadFiltersFromServerOnTabChange(): Observable<Filter[]> {
    return this.filterService.loadFiltersList('curationInfo', this.curationType, this.curationType, { applicationId: this.currentApp.id});
  }

  private loadFiltersFromServer(): Observable<any> {
    if (this.filterService.areFiltersInCache()) {
      let needReloadFilters = false;
      this.filterService.restoreState();
      this.filterService.getFormFilter().pipe(take(1)).subscribe(data => {
        needReloadFilters = isEmpty(data);
      });
      return needReloadFilters ? this.reloadFilters() : this.filterService.getCurrentSelectedFilterQueryFromStore();
    }
    else {
      return this.reloadFilters();
    }
  }

  private reloadFilters(): Observable<any> {
    return this.filterService.loadFiltersList('curationInfo', this.curationType, this.curationType, { applicationId: this.currentApp.id}).pipe(
      flatMap(() => {
        return this.filterService.getCurrentSelectedFilterQueryFromStore();
      })
    );
  }

  private setFilterResultsCounterMessage(filterResultsCounter: Number): void {
    this.filteredResultsMessage = filterResultsCounter.toString() + ' Filtered results';
  }

  private loadDataFromServer(appliedFilterQueryString: string): Observable<IcurationWorklistItem[]> {
    this.toggleSpinner(true);
    if (this.confMap.length > 1 && this.curationType != CurationSettings.CURATION_WORKLIST) {
      this.currentConf = this.confMap.filter(data => data['type'] === this.curationType)[0];
    }
    else {
      this.currentConf = this.confMap.filter(data => {
          if (has(data, CurationSettings.CURATION_GRANTED_KB)) {
            return data[CurationSettings.CURATION_GRANTED_KB] === this.curationActionCreatorService.getGrantedKB();
          }
          else {
            return data['id'] === this.curationActionCreatorService.getActiveKB();
          }
        }
      )[0];
    }

    this.curationWriteMode = (this.authService.doesUserHasPermission(CurationItemPermissions.WRITE_CURATION_ITEM_PERMISSION)
      || this.authService.doesUserHasPermission(this.getTypeSpecificPermission('WRITE'))) && !get(this.currentConf, 'ui.readOnly', false);

    //return new Promise((res) => {
     return this.curationActionCreatorService.getCurationWorkList(this.curationType, this.currentConf, appliedFilterQueryString)
        .map(data => {
          this.dataIsLoaded$.next(true);
          this.toggleSpinner(false);
          if (data) {
            if (data['curationList']) {
              if (!!this.grantedActionsTable && this.grantedActionsTable.length > 0) {
                data['curationList'].forEach(item => this.curationDashboardService.adaptDataToGridWithGrantedAction(item, this.authService.user.organization,
                  this.isCurationTypeInGrantedTable(CurationSettings.GRANTED_ACTIONS_CLONE_ACTION, item.type)));
              }
              else {
                data['curationList'].forEach(item => this.curationDashboardService.adaptDataToGrid(item, this.currentConf, this.authService.user.organization));
              }
              this.setFilterResultsCounterMessage(data['curationList'].length);
            }
            return data['curationList'];
          }
          else {
            this.setFilterResultsCounterMessage(0);
            return [];
          }
        })
        .catch((error: any) => {
          this.notificationMessageService.error('Fail to load data');
          this.toggleSpinner(false);
          return [];
        })
        .finally(() => {
          //res();
        });
    //});
  }

  private getTypeSpecificPermission(permission: string) {
    return `CURATIONITEM.${this.curationType.toUpperCase()}.${permission.toUpperCase()}`;
  }

  private createCurationItemWithOwner(curationToCreate): Observable<any> {
    const ret = this.curationDashboardService.createCurationItem(this.curationToCreate);
    if (curationToCreate.type === 'aberration') {
      return ret;
    }
    return ret
      .switchMap((response: any) => {
        const curationItem = response.curationItem;
        const curationData = response.curationData;
        const opinion = response.opinion;
        return this.curationActionCreatorService.setCurationItemOwner(curationItem.id, curationItem.activeRevisionId,
          curationItem.workflowRequestId, opinion.practitioner, curationItem.type, curationData.status)
          .map(res1 => response);
      });
  }

  private createCuration(model, relatedEntities = null, skipCheckIfCurationItemIsExist?: boolean, forceUpdateRelatedEntities?: boolean) {
    let obs$;
    this.curationToCreate = this.curationDashboardService.prepareCurationItem(model, this.curationType);
    const confRoot = this.generalDbConf; // this.confMap.filter(data => data['type'] === CurationSettings.CURATION_KB)[0];

    // GEN-42234: In case of cloning, coping 'relatedEntities' of the source curation item as is
    // GEN-128997: Placement cloning needs to force related data updating , because we can change connected clinical trial and pathway
    if (forceUpdateRelatedEntities) {
      CurationUtils.updateRelatedEntities(confRoot, this.curationToCreate, null, true, forceUpdateRelatedEntities);
    }
    else {
      if (relatedEntities) {
        this.curationToCreate['relatedEntities'] = relatedEntities;
      } else {
        CurationUtils.updateRelatedEntities(confRoot, this.curationToCreate, null, true);
      }
    }

    if (!!skipCheckIfCurationItemIsExist) {
      obs$ = Observable.of(CurationEditorHelper.CURATION_ITEM_NOT_FOUND);
    } else {
      obs$ = this.curationDashboardService.getCurationItemByKeys(this.curationToCreate, true, this.getAdditionalValidationSet(), this.generalDbConf)
        .take(1).publish();
      obs$.connect();
    }
    obs$.subscribe((data) => {
      if ((data['error'] && data['status'])) {
        if (data.status == CurationEditorHelper.ERROR_ITEM_NOT_FOUND) {
          this.createCurationItemWithOwner(this.curationToCreate).subscribe((response: any) => {
              this.logservice.info('curation item was created successfully with response : `${response.createCurationItemStatus}`', CurationEditorHelper.CURATION_DASHBOARD_CONTEXT);
              const params = this.curationDashboardService.openEditorParams(response);
              this.openEditor(params.curationId, params.wfId, params.revisionId, params.curationType, model.relatedEntity);
            },
            error => {
              // TODO: fix logger error if returns 'Conflict' message
              // this.logservice.error(error, CurationEditorHelper.CURATION_DASHBOARD_CONTEXT);
              const typeName = CurationTypes[this.curationType];
              this.toggleSpinner(false);
              this.curationItemModelSubscriber$ = this.modalLoader.popupModal(PlaceholderModalComponent, {
                title: `For ${typeName} not found one or more source items`,
                componentToLoad: CurationItemNotFoundComponent,
                buttons: {
                  approveBtn: 'Ok'
                },
                payload: { },
                approveCallback: (model) => {
                  return Observable.of(true);
                },
              }, ModalTypes.ALERT)
                .finally(() => {
                })
                .subscribe(() => {
                });
            });
        }
        else if (data.status == CurationEditorHelper.MULTIPLE_CHOICES) {
          this.toggleSpinner(false);
          this.showValidationWarning(data);
        }
        else {
          this.toggleSpinner(false);
          const errMsg = data.error.details ? data.error.details : data.message ? data.message : '';
          this.notificationMessageService.error('Fail to create curation, ' + errMsg);
        }
      }
      else if (this.curationType == CurationSettings.CURATION_ABERRATION &&  // ToDo: this code should be checked
        data.metadata && data.metadata['aberrationSubClass'] &&
        data.metadata['aberrationSubClass'] === 'pnotation' &&
        this.curationTypeByFormName.get(this.curationToCreate.aberration['selectedFormName']) === 'gnotation') {
        this.curationDashboardService.createCurationItem(this.curationToCreate).subscribe((response: any) => {
          const params = this.curationDashboardService.openEditorParams(response);
          this.openEditor(params.curationId, params.wfId, params.revisionId, params.curationType);
        });
      }
      else {
        this.loadMatchItemForm(data, true);
      }
      return data;
    }, error => {
      this.toggleSpinner(false);
      this.notificationMessageService.error(error);
      return error;
    }
  );
    return obs$;
  }

  private toggleSpinner(status) {
    this.loading = status;
  }

  private getCurationItemName(curationType, content) {
    switch (curationType) {
      case CurationSettings.CURATION_CLINICALTRIAL:
        return content.trialId;
      case  CurationSettings.CURATION_REGIMEN:
        return content.regimenName;
      case   CurationSettings.CURATION_TREATMENTPLAN:
        return content.treatmentPlanName;
      case CurationSettings.CURATION_PLACEMENT:
        return content.placementName;
      case CurationSettings.CURATION_PATHWAY_BPMN:
        return get(content, 'pathwayBpmnName', content.disease.display);
      default:
        return '';
    }
  }

  /**
   * this function will inject to worklist actions and will call from there
   */
  private openCloningSelectionForm(self) {
    if (self.rowData.type) {
      this.curationActionCreatorService.getState(['definitions'])
        .take(1)
        .subscribe((data => {
          const conf = Array.from(data.values()).filter(data => data['type'] === self.rowData.type)[0];
          const cloneConf = get(conf, 'ui.forms.cloneForms.' + self.rowData.type);
          const messageContent = this.getWarningMessageContent(self.rowData.type);
          if (this.isClonedFromAnotherOrg(self.rowData.kb)) {
            this.curationItemModelSubscriber$ = this.modalLoader.popupModal(PlaceholderModalComponent,
              {
                title: '',
                componentToLoad: CurationModalMessageComponent,
                buttons: {
                  approveBtn: 'Yes',
                  declineBtn: 'No'
                },
                payload: {
                  title: '',
                  content: messageContent
                },
                approveCallback: () => {
                  this.showCloneForm(cloneConf, self.rowData);
                  return Observable.of(true);
                },
              }, ModalTypes.ALERT)
              .subscribe(() => {
              });
          }
          else {
            this.showCloneForm(cloneConf, self.rowData);
          }
        }));
    }
  }

  private showCloneForm(cloneConf, rowData) {

    let cloningSelectionFormData: any = {
      'curation': rowData,
      'fieldToChange': cloneConf['fieldToChange']
    };
    const componentPayload = {
      formName: get(cloneConf, 'formName', ''),
      itemData: cloningSelectionFormData,
    };
    this.modalSubscriber$ = this.modalLoader.popupModal(PlaceholderModalComponent,
      new PlaceholderModalLoaderPayload(
        cloneConf.title,
        CurationCloningSelectionComponent,
        'OK',
        'Cancel',
        componentPayload,
        (model) => {
          if (model) {
            cloningSelectionFormData = model;
            // temp condition until we integrate aberration to the generic flow
            if (get(model, 'curation.type') === 'aberration') {
              this.cloneDiseaseEvent(model);
            }
            else {
              const curationItemId = model['curation']['curationItemId'];
              const revisionId = model['curation']['revisionId'];
              const curationType = model['curation']['type'];
              this.curationActionCreatorService.getCurationItemV1(curationItemId, revisionId, curationType).subscribe(res => {
                  if (res.status === CurationEditorHelper.ERROR_ITEM_NOT_FOUND.toString()) {
                    this.notificationMessageService.error('Cannot load curation item: ' + res['error'] + '. ' + res['details']);
                  }
                  else {
                    const cont = res.curationData['content'];
                    const form = model['form'];
                    this.curationType = curationType;
                    this.curationDashboardService = this.getCurationDashboardService();
                    this.curationDashboardService.updateDataFromModel(form, cont, this.isClonedFromAnotherOrg(rowData.kb), this.grantedActionsTable);
                    switch (curationType) {
                      case CurationSettings.CURATION_PLACEMENT:
                        this.createCuration(cont, res.curationData['relatedEntities'], undefined, true);
                        break;
                      case CurationSettings.CURATION_PATHWAY_BPMN:
                        this.handlePathwayClone(cont, res, form);
                        break;
                      default:
                        this.createCuration(cont, res.curationData['relatedEntities']);
                        break;
                    }
                  }
                }
              );
            }
          }
          return Observable.of(model);
        }
      ), ModalTypes.NONE)
      .subscribe(model => {
      });
  }

  private updateAndGetPathwayBpmnName(curationData, form): string {
    let bpmnName = curationData['disease']['display'];
    // check if name field in dynamic form exists
    if (form.hasOwnProperty(CurationSettings.PATHWAYBPMN_NAME)) {
      // check if name field is empty
      const name = get(form, CurationSettings.PATHWAYBPMN_NAME);
      if (name === null || name === '') {
        set(curationData, CurationSettings.PATHWAYBPMN_NAME, bpmnName);
      }
      bpmnName = get(curationData, CurationSettings.PATHWAYBPMN_NAME);
      curationData.title = bpmnName;
    }
    return bpmnName;
  }

  private prepareCurationItem(curationData, curationItem) {
    this.curationToCreate = this.curationDashboardService.prepareCurationItem(curationData, this.curationType);
    const confRoot = this.generalDbConf; // this.confMap.filter(data => data['type'] === CurationSettings.CURATION_KB)[0];

    if (curationItem.curationData['relatedEntities']) { // GEN-42234: In case of cloning, coping 'relatedEntities' of the source curation item as is
      this.curationToCreate['relatedEntities'] = curationItem.curationData['relatedEntities'];
    }
    else {
      CurationUtils.updateRelatedEntities(confRoot, this.curationToCreate, null, true);
    }
  }

  // todo: check with Ilona
  // applyFilter(filter: string) {
  //   this.appliedFilter = filter;
  //   this.loadDataFromServer();
  // }

  /**
   * Method Purpose : clone pathway tree from source disease to destination disease ,
   * @param curationData : source pathway curation data
   * @param curationItem :source pathway curation Item
   */
  private handlePathwayClone(curationData, curationItem, form) {
    this.prepareCurationItem(curationData, curationItem);
    const bpmnName = this.updateAndGetPathwayBpmnName(curationData, form);

    const messageData = { error: { message: 'can\'t be cloned for given discipline and given cancer type, such pathwaybpmn already exists for current organization'}};
    const curationItem$ = this.curationDashboardService.getCurationItemByKeys(this.curationToCreate, true, this.getAdditionalValidationSet(), this.generalDbConf)
      .take(1)
      .publish();
    curationItem$.connect();
    curationItem$.subscribe((data) => {
      const notSuitableToClone =
        (has(data, 'curationData.status') && (get(data, 'curationData.status', CurationSettings.CURATION_STATUS_ARCHIVED) != CurationSettings.CURATION_STATUS_ARCHIVED))
        || (has(data, 'status') && (data.status != CurationEditorHelper.ERROR_ITEM_NOT_FOUND || data.status == CurationEditorHelper.MULTIPLE_CHOICES));
      if (notSuitableToClone) {
        this.showValidationWarning(messageData);
      }
      else {
        const bpmnIdentifier = curationData['bpmn']['bpmnIdentifier'];
        const kb = this.getKnowledgeBase(curationItem);
        this.bpmnXmlService.getBpmnXml(bpmnIdentifier.deploymentId, bpmnIdentifier.name, kb)
          .subscribe(xml => {
              xml = this.getNewXml(xml, bpmnName, bpmnIdentifier.name, curationData['discipline']['code']);
              this.getBpmnDeploymentService().saveBpmnXML(bpmnName, xml, false, kb).subscribe(
                bpmnNewIdentifier => {
                  this.updateCurationData(curationData, bpmnNewIdentifier);
                  const nodeUpdate = new CurationUpdateNode('head_node_id');
                  this.curationService.setNodeUpdate(nodeUpdate);
                  this.createCuration(curationData, curationItem.curationData['relatedEntities'], true);
                },
                httpError => this.handleError('Error Saving pathway: ', bpmnIdentifier.name, httpError.message));
            },
            httpError => this.handleError('Error loading pathway: ', bpmnIdentifier.name, httpError.message));
      }
    }, error => {
        this.toggleSpinner(false);
        this.notificationMessageService.error(error);
        return error;
      }
    );
  }

  private getKnowledgeBase(curationItem): string {
    if (curationItem && curationItem.curationData) {
      const knowledgeBaseContext = curationItem.curationData.context.find(val => val.resourceType === 'kb');
      return knowledgeBaseContext ? knowledgeBaseContext.reference.toString() : undefined;

    }
    return undefined;
  }

  private handleError(msg, diseaseName, httpErrorMsg) {
    this.notificationMessageService.error(msg + diseaseName + `error - ${httpErrorMsg.message}`);
    this.toggleSpinner(false);
  }

  /**
   * Methods purpose : creating a new updated xml based on the given pathway xml
   */
  private getNewXml(xml, newDiseaseName, oldDiseaseName, discipline) {
    const headNodePrefix = 'id="head_node_id" name="';
    xml = xml.replace(headNodePrefix + oldDiseaseName, headNodePrefix + newDiseaseName);
    return xml.replace(camelCase(oldDiseaseName) + discipline, camelCase(newDiseaseName) + discipline);
  }

  private updateCurationData(curationData, bpmnNewIdentifier) {
    curationData['bpmn']['bpmnIdentifier'].name = bpmnNewIdentifier.name;
    curationData['bpmn']['bpmnIdentifier'].deploymentId = bpmnNewIdentifier.deploymentId;
    curationData['bpmn']['bpmnIdentifier'].processId = bpmnNewIdentifier.processId;
    curationData['diseaseDisplay'] = bpmnNewIdentifier.name;
    curationData['bpmn']['nodes']['head_node_id']['data'].name = bpmnNewIdentifier.name;
  }

  private getBpmnDeploymentService(): BpmnDeploymentService {
    return this.injector.get(BpmnDeploymentService);
  }

  private prepareActionsByGrantedTable() {

    if (!!this.grantedActionsTable) {
      this.grantedActionsTable = cloneDeep(this.grantedActionsTable);
      // for best performance re-calculate initial data
      this.grantedActionsTable.forEach(action => {
        if (action.action === CurationSettings.GRANTED_ACTIONS_CLONE_ACTION) {
          action.userIsPermittedForAction = action.roles.includes(this.authService.user.role);
          // put myself into permitted sources
          action.types.map(descr => {
            if (!descr.source.includes(this.generalDbConf.id)) { descr.source.push(this.generalDbConf.id); }
          });
        }
      });

      if (!this.viewOnlyMode && this.grantedCloneEnabled()) {
        const cloneGrantedAction = WorklistExecute.builder(CurationSettings.GRANTED_ACTIONS_CLONE_ACTION, 'Clone', this.openCloningSelectionForm.bind(this));
        cloneGrantedAction.enableCondition = this.grantedClonedEnabledForItem.bind(this);
        this.executeActions = [cloneGrantedAction];
      }
    }
  }

  private isCurationTypeInGrantedTable(actionName: string, curationType: string): boolean {
    let result = true;
    if (!!this.grantedActionsTable) {
      result = this.grantedActionsTable.some(el => el.action === actionName && el.types.some(descr => descr.curationType.toLowerCase() === curationType.toLowerCase()));
    }
    return result;
  }

  private grantedCloneEnabled() {
    return this.curationType === CurationSettings.CURATION_WORKLIST ||
      this.grantedActionsTable.some(action => action.action === CurationSettings.GRANTED_ACTIONS_CLONE_ACTION && action.types.some(descr => descr.curationType === this.curationType));
  }

  private isClonedFromAnotherOrg(kb: string) {
    return kb != this.curationActionCreatorService.getActiveKB();
  }

  private getWarningMessageContent(type: string): string {
    let typeValue = type;
    switch (type) {
      case CurationSettings.CURATION_PATHWAY_BPMN:
        typeValue = 'pathway';
        break;
      case CurationSettings.CURATION_TREATMENTPLAN:
        typeValue = 'treatment plan';
        break;
      default:
        break;
    }
    return CurationSettings.CURATION_CLONE_WARNING.replace(/type/g, typeValue);
  }
}
